import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-logic",
  "use": "foquz-icon-logic-usage",
  "viewBox": "0 0 20 17",
  "content": "<symbol viewBox=\"0 0 20 17\" fill=\"none\" id=\"foquz-icon-logic\"><path d=\"M9.988 5.022v3.024m0 0v3.941m0-3.94h-5.66c-.667 0-1.332.662-1.332 1.326v2.636m6.992-3.963h5.66c.666 0 1.332.663 1.332 1.327v2.636m-13.984 0a1.996 1.996 0 100 3.991 1.996 1.996 0 000-3.991zm13.984 0a1.996 1.996 0 100 3.99 1.996 1.996 0 000-3.99zm-5.005-9.013a1.996 1.996 0 11-3.99 0 1.996 1.996 0 013.99 0zm0 11.008a1.995 1.995 0 11-3.99 0 1.995 1.995 0 013.99 0z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol